import React, { Component } from 'react';
import { FORMAT_NUMBER, SERVICE_API, CURRENCY, BASE_URL } from '../libs/utils/Const';

class SearchModal extends Component {
    componentWillUnmount() {
        const { cleanData } = this.props;
        cleanData();
    }
    render() {
        const { ShowSearchModal,
            suggestions,
            ChangeQuantitySuggestions,
            AddItem,
            SelectItemSuggestion,
            itemIndexSuggestion,
            itemSearch,
            ChangeSearchItem,
            SearchItemsModal,
            SearchStockByItem,
            ShowWithStock,
            ChangeShowWithStock
        } = this.props;
        return (
            <div className="modal fade" id="searchModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="searchModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <div className="col-md-1 p-2 d-none">
                                {/* <select 
                                    className="text-center cursor-pointer btn btn-primary" style={{backgroundColor:"#e9ecef", color:"#495057", border: "1px solid #ced4da", align: "right"}}>
                                        <option value="1">MXP</option>
                                        <option value="1">USD</option>
                                </select> */}
                            </div>
                            <div className="col-10 ">
                                <div className="input-group m-2">
                                    <div className="input-group-prepend" data-toggle="modal">
                                        <span className="input-group-text  btn-outline-secondary" id="basic-addon1" onClick={SearchItemsModal} ><i className="fa fa-barcode" aria-hidden="true"></i></span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control  
                                        btn-outline"
                                        placeholder="Inserte el código o nombre del artículo"
                                        aria-label="Username"
                                        aria-describedby="basic-addon1"
                                        value={itemSearch}
                                        onChange={(event) => ChangeSearchItem(event.nativeEvent.target.value)}
                                        onKeyPress={(event) => { event.key === 'Enter' && SearchItemsModal() }} />
                                </div>
                            </div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} onClick={ShowSearchModal}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="table-responsive scrollSearchs">
                                <table className="table">
                                    <thead className='sticky-headerPOS'>
                                        <tr>
                                            <th scope="col" className="border-0 bg-light">
                                                <div className="p-2 px-3 text-uppercase">Artículo</div>
                                            </th>
                                            <th scope="col" className="border-0 bg-light text-left">
                                                <div className="py-2 text-uppercase">Disponible</div>
                                            </th>
                                            <th scope="col" className="border-0 bg-light">
                                                <div className="py-2 text-uppercase">Precio</div>
                                            </th>
                                            <th scope="col" className="border-0 bg-light">
                                                <div className="py-2 text-uppercase">Cantidad</div>
                                            </th>
                                            <th scope="col" className="border-0 bg-light">

                                                <div className=" text-uppercase">

                                                    <>
                                                        <label className="switch mr-3" >
                                                            Stock
                                                        </label>
                                                        <label className="switch" >
                                                            <input type="checkbox"
                                                                // disabled={ShowWithStock ? false : true}
                                                                checked={ShowWithStock ? ShowWithStock : false}
                                                                onChange={() => ChangeShowWithStock()}
                                                            />
                                                            <span className="sliderCO round"></span>
                                                        </label>
                                                    </>

                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!!suggestions &&
                                            suggestions.map((item, index) => {
                                                return (
                                                    <tr
                                                        key={`SearchItemId${index}`}
                                                        onClick={() => SelectItemSuggestion(index)}
                                                        style={{ background: index === itemIndexSuggestion && '#FFF8D2' }}>
                                                        <th scope="row" className="border-0" onDoubleClick={() => AddItem(item)}>
                                                            <div className="p-2">
                                                                <img src={item.PicturName ? (BASE_URL + SERVICE_API.getImage + '/' + item.PicturName) : require('../images/noImage.png')} alt="" width="70" className="img-fluid rounded shadow-sm" />
                                                                <div className="ml-3 d-inline-block align-middle">
                                                                    <h5 className="mb-0">
                                                                        <a href="#" className="text-dark d-inline-block align-middle" data-dismiss="modal" data-toggle="modal" onClick={() => SearchStockByItem(item.ItemCode)}>{item.ItemCode}</a>
                                                                    </h5><span className="text-muted font-weight-normal font-italic d-block articulosr">{item.ItemName.substring(0, 52)}</span>
                                                                </div>
                                                            </div>
                                                        </th>
                                                        <td className="align-middle"><strong>{FORMAT_NUMBER.new(item.OnHand)}</strong></td>
                                                       <td className="align-middle"><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(item.Price)}</strong></td>
                                                        <td className="align-middle text-center">
                                                            <strong>
                                                                <input
                                                                    type="number"
                                                                    defaultValue={1} min={1}
                                                                    className="text-center input-cantidad"
                                                                    value={item.Quantity}
                                                                    onChange={(event) => { ChangeQuantitySuggestions(event.nativeEvent.target.value, index) }} />
                                                            </strong>
                                                        </td>
                                                        <td className="align-middle text-center">
                                                            <a href="#" className="text-dark" onClick={() => AddItem(item)}>
                                                                <i className="fa fa-plus-square-o" style={{ fontSize: "large" }}></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>




                        </div>
                        <div className="modal-footer">

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchModal;